<template>
  <div id="main-content-header">
    <el-row type="flex" align="middle" justify="space-between">
      <el-col :span="12">
        <h1 :style="headerStyle">{{title}}</h1>
      </el-col>
      <el-col :span="12">
        <slot></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'MainContentHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    fontSize: {
      type: String,
      default: '32',
    },
  },
  computed: {
    headerStyle() {
      return `font-size: ${this.fontSize}px`;
    },
  },
};
</script>

<style scoped lang="scss">
#main-content-header {}
</style>
